import React, {useContext} from 'react';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import { SettingsBannerContext } from '../../../../contexts/SettingsBannerContext';
import { MasterBannerContext } from '../../../../contexts/MasterBannerContext';

export default function Element(item) {
  const element = item.item;
  const active = item.active;
  const background = element.type.toLowerCase() === "in" ? "#1B9ADA" : "#DD1B58";
  const stepColors = ["#AE56A5", "#E28F57", "#E55581", "#7DE5B8", "#1B9ADA", "#e1eb34", "#e1eb34", "#eba534"];
  const { setReload, setLayerActive, layerActive } = useContext(SettingsBannerContext);
  const { master, setMaster } = useContext(MasterBannerContext);
  function addOrRemoveObjectFromArray(array, object) {
    const index = array.findIndex(item => JSON.stringify(item) === JSON.stringify(object));
    if (index !== -1) {
      array.splice(index, 1);
    } else {
      array.push(object);
    }
    return array; 
  }  
  function ChangeElement(e) {
  var id = master.elements.findIndex(el => el.id === item.item.name);
   if (item.item.type.toLowerCase() === layerActive[0].type.toLowerCase() && item.item.name === layerActive[0].element.id) return; 
   let newActiveLayer = {element: master.elements[id], type: item.item.type.toLowerCase()}
  if(e.ctrlKey || e.shiftKey){
    let layerActiveCopy = [...layerActive] 
    if(newActiveLayer.type !== layerActiveCopy[0].type){
      setLayerActive(layerActiveCopy)
    }else{
      let result = addOrRemoveObjectFromArray(layerActiveCopy, newActiveLayer)
      result.length === 0 ? setLayerActive([{element: master.elements[id], type: item.item.type.toLowerCase()}]) : setLayerActive(result)
    }
  }
  else{
    setLayerActive([newActiveLayer])
  }
  return
  }
  function ChangeValue(element, evt) {
    try {
      if (evt.key === "Enter") {
        var scrollPosition = document.getElementsByClassName('containerElements')[0].scrollTop
         document.getElementsByClassName('containerElements')[0].style.overflow = 'hidden'

       
        const value = parseFloat(evt.target.value.replace(',', '.').replace('s', '')).toFixed(1);
        if (value >= 0) {
          var newBanner = JSON.parse(JSON.stringify(master));
        
          const delay = parseFloat(value).toFixed(1);
          setTimeout(() => {
             document.getElementsByClassName('containerElements')[0].style.overflow = 'auto'
              document.getElementsByClassName('containerElements')[0].scrollTop =  scrollPosition
          }, 100)
          for (var i = 0; i < newBanner.elements.length; i++) {
            if (element.name === newBanner.elements[i].id) {
              if (element.type === "IN") {
                try {
                  const customKeyframe = newBanner.elements[i].animation.in.customKeyframe;
                  if (customKeyframe) {
                    newBanner.elements[i].customKeyframe.in.delay = delay;
                  } else {
                    newBanner.elements[i].animation.in.delay = delay;
                  }
                } catch  {                  
                  newBanner.elements[i].animation.in.delay = delay;
                }
              }
              else {
                try {
                  const customKeyframe = newBanner.elements[i].animation.out.customKeyframe;
                  if (customKeyframe) {
                    newBanner.elements[i].customKeyframe.out.delay = delay;
                  } else {
                    newBanner.elements[i].animation.out.delay = delay;
                  }
                } catch  {                  
                  newBanner.elements[i].animation.out.delay = delay;
                }
              }
              evt.target.value = parseFloat(value).toFixed(1) + "s";
              
              setMaster(newBanner);
              setReload(true);
              break;
            }
          }
        } else {
          evt.target.value = item;
        }
      }
    } catch (error) {  }  


  }

  let reducedLayer;
  let reducedAnimation;

  if (element.name.length > 15) {
    reducedLayer = element.name.slice(0, 15)+'...';
  } else {
    reducedLayer = element.name;
  }

  if (element.animation.length > 8) {
    reducedAnimation = element.animation.slice(0, 8)+'...';
  } else {
    reducedAnimation = element.animation;
  }

  return (
    <div style={{display: 'flex', background:  active  ? '#F7F7F7' : 'transparent', borderRadius: '4px', position: 'relative', height: '30px', marginBottom: '-5px', justifyContent: 'flex-start', width: '100%', }}>
      <div onClick={() => item.openGroup(element.name)} style={{display: element.children && element.type.toLowerCase() === "in" ? 'flex' : 'none', position: 'absolute', top: '-2px'}}>
        { item.group ?
        <FolderZipIcon sx={{ color: 'rgb(99, 186, 230)' }} /> : <FolderOpenIcon sx={{ color: 'rgb(99, 186, 230)' }}/> }
      </div>
      <div onClick={ChangeElement} style={{width: '170px', textAlign: 'center', fontSize: '14px',  padding: '0 50px', display: 'flex'}}>
        <div style={{justifyContent: 'end', verticalAlign: 'middle', textAlign: 'center'}}>
        <span style={{  
          marginTop: '8px',
          height: '12px',
          width: '12px',
          backgroundColor: stepColors[item.item.step - 1],
          borderRadius: '50%',
          display: 'inline-block'}}
          ></span>
          </div>
          
        <span style={{textAlign: 'center', fontSize: '14px', height: '100%', borderRadius: '4px', lineHeight: '17px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', userSelect: 'none'}}>
        {reducedLayer}
        </span>
      </div>
      <div style={{width: '130px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <input
          onKeyPress={(evt) => ChangeValue(element, evt)}
          style={{cursor: 'pointer', width: '56px', height: '25px', textAlign: 'center', fontSize: '14px', borderRadius: '4px', border: 0}}
          placeholder={element.delay.toString() + "s"}
        />
      </div>
      <div onClick={ChangeElement} style={{width: '130px', display: 'flex', justifyContent: 'center', alignItems: 'center',  padding: '0 42px'}}>
        <span style={{textAlign: 'center', display: 'flex', alignItems: 'center', userSelect: 'none', justifyContent: 'center', fontSize: '14px', background: background, height: '24px', borderRadius: '4px', lineHeight: '17px', width: '80px', color: '#ffffff',}}>
          {element.type.toLowerCase() === "in" ? "Entrada" : "Saída" }
        </span>
      </div>
      <div onClick={ChangeElement} style={{width: '150px', display: 'flex', justifyContent: 'center', alignItems: 'center',  padding: '0 32px'}}>
      <span style={{textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', background: active ? 'white' : 'white', height: '24px', borderRadius: '4px', lineHeight: '17px', width: '80px'}}>
        {reducedAnimation}
      </span>
      </div>
      <div onClick={ChangeElement} style={{width: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center',  padding: '0 40px'}}>
        <span style={{textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', background: active ? 'white' : 'white', height: '24px', borderRadius: '4px', lineHeight: '17px', width: '55px'}}>
        {element.duration ? `${(element.duration / 1000).toFixed(1)}s` : "-"}
        </span>
      </div>
      <div onClick={ChangeElement} style={{width: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0 40px'}}>
      <span style={{textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', background: active ? 'white' : 'white', height: '24px', borderRadius: '4px', lineHeight: '17px', width: '55px'}}>
        {element.direction ? element.direction : "-"}
        </span>
      </div>
    </div>
  )
}